<template>
    <div v-if="timeRemaining > 0" class="timer__wrapper__time">
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--days">{{ countdown.days }}</div>
            Dagen
        </div>
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--hour">{{ countdown.hours }}</div>
            Uren
        </div>
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--minutes">{{ countdown.minutes }}</div>
            Minuten
        </div>
        <div class="timer__wrapper__time__item">
            <div class="countdown-item countdown-item--seconds">{{ countdown.seconds }}</div>
            Seconden
        </div>
    </div>
    <div v-else class="timer__wrapper__time">Tijd verstreken</div>
</template>

<script>
    import { ref, onMounted, onUnmounted, watch } from 'vue';

    export default {
        props: {
            time: {
                type: String,
                required: true
            }
        },
        setup(props) {
            const timeRemaining = ref(0);
            const countdown = ref({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            let counterUpdater = null;

            const calculateTimeRemaining = () => {
                const currentTime = new Date().getTime();
                const expirationTime = new Date(props.time).getTime();
                return expirationTime - currentTime;
            };

            const getTime = () => {
                return {
                    days: Math.floor(timeRemaining.value / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((timeRemaining.value / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((timeRemaining.value / (1000 * 60)) % 60),
                    seconds: Math.floor((timeRemaining.value / 1000) % 60)
                };
            };

            const update = () => {
                countdown.value = getTime();
            };

            const start = () => {
                update();

                counterUpdater = setInterval(() => {
                    timeRemaining.value -= 500;

                    if (timeRemaining.value < 0) {
                        clearInterval(counterUpdater);
                        timeRemaining.value = 0;
                    } else {
                        update();
                    }
                }, 1000);
            };

            watch(() => props.time, (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    timeRemaining.value = calculateTimeRemaining();
                    if (timeRemaining.value > 0) {
                        start();
                    }
                }
            }, { immediate: true });

            onMounted(() => {
                timeRemaining.value = calculateTimeRemaining();
                if (timeRemaining.value > 0) {
                    start();
                }
            });

            onUnmounted(() => {
                if (counterUpdater) {
                    clearInterval(counterUpdater);
                }
            });

            return { countdown, timeRemaining };
        }
    };
</script>
